// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"04e00e2c","498":"98e19c76","703":"ec2b548d"}[chunkId] + ".chunk.js";
};